<template>
  <el-dialog
    top="50px"
    width="500px"
    title="Chỉnh sửa thông tin"
    :visible="visible"
    :show-close="!callingAPI"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :show-message="true"
      size="medium"
      label-position="top"
    >
      <el-row
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="name"
label="Tên">
            <el-input
v-model="form.name"
placeholder="Nhập thông tin" />
          </el-form-item>
        </el-col>
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="author"
label="Tác giả">
            <el-input
v-model="form.author"
placeholder="Nhập thông tin" />
          </el-form-item>
        </el-col>
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="description"
label="Mô tả">
            <el-input
              v-model="form.description"
              type="textarea"
              placeholder="Nhập thông tin"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
slot="footer"
class="dialog-footer">
      <el-button
:disabled="callingAPI"
size="medium"
@click="$emit('close')">
        Đóng
      </el-button>
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
      >
        Lưu
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fileServices from "@/services/file";
import { notification } from "@/utils/common";

export default {
  name: "FileFormPopup",
  props: {
    item: Object,
    visible: Boolean,
  },
  data() {
    return {
      form: {
        name: this.item ? this.item.extra?.name : "",
        author: this.item ? this.item.extra?.author : "",
        description: this.item ? this.item.extra?.description : "",
      },
      callingAPI: false,
    };
  },
  computed: {
    rules() {
      return {
        name: [
          {
            required: true,
            message: "Tên không được để trống",
            trigger: ["blur", "change"],
          },
        ],
      };
    },
    payload() {
      return {
        ...this.item,
        extra: {
          ...this.item.extra,
          ...this.form,
        },
      };
    },
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true;
          fileServices
            .update(this.payload)
            .then((response) => {
              this.callingAPI = false;
              this.$emit("reload", response);
              notification(this, "success", "update", `${this.form.name}`);
              this.$emit("close");
            })
            .catch(() => {
              this.callingAPI = false;
              notification(this, "error", "update", `${this.form.name}`);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
